import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      quote: "Integrand Analytics has been instrumental in scaling our loan underwriting operations. Their attention to detail and deep CRE expertise has allowed us to process significantly more deals without compromising quality.",
      author: 'Director of Operations',
      position: 'CMBS Lender',
      company: 'Major CMBS Lender'
    },
    {
      id: 2,
      quote: "The lease abstraction team at Integrand delivers consistent, high-quality work that we can rely on. They've become a true extension of our in-house team.",
      author: 'VP of Asset Management',
      position: 'National REIT',
      company: 'Fortune 500 REIT'
    },
    {
      id: 3,
      quote: "Working with Integrand has transformed how we approach financial modeling. Their custom models and responsive team have significantly improved our deal turnaround times.",
      author: 'Managing Director',
      position: 'Investment Bank',
      company: 'Global Investment Bank'
    },
    {
      id: 4,
      quote: "The quarterly reporting support from Integrand has been exceptional. Accurate, timely, and professionally presented - exactly what our investors expect.",
      author: 'Partner',
      position: 'Private Equity',
      company: 'CRE Private Equity Fund'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from commercial real estate professionals who trust Integrand Analytics
          </p>
        </div>

        {/* Testimonial Carousel */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 relative">
            {/* Quote Icon */}
            <div className="absolute -top-4 left-8">
              <div className="w-12 h-12 bg-[#005B63] rounded-xl flex items-center justify-center">
                <Quote className="w-6 h-6 text-white" />
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="pt-4">
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8 italic">
                "{testimonials[currentIndex].quote}"
              </p>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900">
                    {testimonials[currentIndex].author}
                  </p>
                  <p className="text-gray-500 text-sm">
                    {testimonials[currentIndex].position}
                  </p>
                  <p className="text-[#005B63] text-sm font-medium">
                    {testimonials[currentIndex].company}
                  </p>
                </div>

                {/* Navigation */}
                <div className="flex gap-2">
                  <button
                    onClick={prevTestimonial}
                    className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:border-[#005B63] hover:text-[#005B63] transition-colors"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:border-[#005B63] hover:text-[#005B63] transition-colors"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex 
                    ? 'bg-[#005B63] w-6' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
